module.exports = __webpack_public_path__ + "img/iconEdm.6c8cf86a.svg";